import moment from 'moment'

// Equality is decided on raw values + `kind`, never on the formatted string.
export const formatValue = (value, kind) => {
  if (value === null || value === undefined || value === '') return '—'

  switch (kind) {
    case 'money':
      return Number(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    case 'date':
      return moment(value).format('MMM D, YYYY')
    case 'days':
      return `${value}d`
    case 'number':
      return Number(value).toLocaleString('en-US')
    default:
      return String(value)
  }
}

export const formatMoney = (value) =>
  Number(value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
